import MyOfferedResource from '@/api/resources/myCreditOffered';
import i18n from '../../plugins/i18n';

const buildQueryPayload = (payload = {}) => {
  const queryPayload = {
    order_by: payload.order_by || 'recent',
    page: payload.page || 1,
  };

  if (payload.filter_by_material_type?.length) {
    queryPayload.filter_by_material_type = payload.filter_by_material_type;
  }

  if (payload.by_status?.length) {
    queryPayload.by_status = payload.by_status;
  }

  if (payload.by_year) {
    queryPayload.by_year = payload.by_year;
  }

  return queryPayload;
};

const state = {
  myOffereds: [],
};

const getters = {
  getMyOffereds: () => (state.myOffereds),
};

const actions = {
  fetchMyOffereds({ commit, dispatch }, payload) {
    MyOfferedResource.index(payload).then((response) => {
      commit('setMyOffereds', response);
      dispatch('removeLoading');
    });
  },

  deleteMyCreditOffered({ dispatch }, payload) {
    MyOfferedResource.delete(payload).then(() => {
      dispatch('addSuccessMessage', i18n.t('success.deleted_credit_offered'));
      dispatch('fetchMyOffereds', {
        business_id: payload.business_id,
        payload: buildQueryPayload(payload),
      });
    });
  },

  updateMyCreditOffered({ dispatch }, payload) {
    MyOfferedResource.update(payload).then(() => {
      dispatch('addSuccessMessage', i18n.t('success.updated_credit_offered'));
      dispatch('fetchMyOffereds', {
        business_id: payload.business_id,
        payload: buildQueryPayload(payload.payload),
      });
    });
  },
};

const mutations = {
  setMyOffereds($state, payload) {
    const stateCopy = $state;
    stateCopy.myOffereds = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
